module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'erfolg',
    综合评价: "Gesamtbewertung",
    inputNotSame: "Eingabe Nicht Gleich",
    example: 'Beispiel',

    // 选择语言
    popupTitle: 'Sprache auswählen',
    // 发送
    send: 'Bestätigen',
    // 发送邮件
    sendEmail: 'E-Mail senden',
    // 改变语言
    changeLanSes: 'Sprachwechsel erfolgreich',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'Stimme des Käufers',
    // 系统解释
    details: 'Auf die Stimme der Käufer hören, hochwertige Produkte und Dienstleistungen anbieten, danke für den Austausch.',
    fileSizeOver: "Datei ist zu groß, es werden nur Bilder unter 10MB unterstützt.",
    lowTextarea: 'Ihr Feedback wird uns helfen, unsere Produkte und Dienstleistungen kontinuierlich zu verbessern.',
    placeholderOrderNo: "Bitte geben Sie die Bestellnummer ein (Format: 000-0000000-0000000)",
    "picUploadSuccessText": "Bild erfolgreich hochgeladen",
    "picUploadErrorText": "Bild-Upload fehlgeschlagen",
    "orderNotExistText": "Die Bestellung existiert nicht",
    "orderInvalidText": "Diese Bestellung ist ungültig",
    "networkErrorText": "Netzwerkfehler",
    "orderErrorText": "Bestellfehler",
    // step1
    formBasic: {
        title: `Registrieren Sie jetzt Ihre Garantie!
Fordern Sie Ihre <span style="color:#F40000">Mystery Box an</span>, exklusives Angebot für Bestandskunden.`,
        form_name: 'Name',
        form_email: 'E-Mail',
        form_order: 'BestellID',
        form_order_error_placeholder: 'Bitte geben Sie die Bestellnummer ein (Format: 000-0000000-0000000)',
        order_why: '*Wie finden Sie Ihre Bestell-ID?',
        order_answer: `*Wir geben Ihre persönlichen Daten nicht an Dritte weiter.`,
        btn_text: 'Jetzt freischalten',
        "form_name_placeholder": "Bitte geben Sie Ihren Namen ein",
        "form_email_placeholder": "Bitte geben Sie Ihre E-Mail-Adresse ein",
        "form_email_error_placeholder": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        "form_order_placeholder": "Bitte geben Sie Ihre Bestellnummer ein"
    },
    // step2
    showGiftCard: {
        title: `Herzlichen Glückwunsch!</br>
Ihre Garantie ist aktiviert!`,
        text: `Teilen Sie Ihr Einkaufserlebnis und Sie können eine <span style="color:#F40000">Mystery
Box</span>.(Etwa 1 Minute)`,
        gift_card_text: 'Was Sie bekommen können',
        btn_text: 'Nächster Schritt'
    },
    // step3
    star: {
        title: 'Sind Sie mit diesem Produkt oder unserem Service zufrieden?',
        text: 'Bitte vergeben Sie eine Sternebewertung für das Produkt unten:',
        star__placeholder: 'Bitte bewerten Sie alle Fragen, bevor Sie absenden!',
        written: 'Schreiben Sie eine Bewertung: <span style="color:#F40000">(Optional)</span>',
        written_placeholder: 'Was hat Ihnen gefallen? Wofür haben Sie dieses Produkt verwendet?',
        btn_text: 'Nächster Schritt'
    },
    // step4
    ensureEmail: {
        title: `Herzlichen Glückwunsch!</br>
Sie haben die Umfrage beendet.
`,
        text: `Bitte bestätigen Sie die E-Mail-Adresse, Sie werden den Geschenkcode über diese E-Mail-Adresse erhalten:
redeem@amazonsurveyzone.com`,
        email_placeholder: 'Bitte bestätigen Sie die E-Mail erneut!',
        btn_text: 'Bestätigen Sie'
    },
    // step5
    channelSelect: {
        title: `Ihr Feedback ist wichtig! `,
        text: `Teilen Sie Ihre Produktbewertungen auf Amazon, um anderen Kunden zu helfen, die richtigen Entscheidungen zu treffen.
Treten Sie jetzt der Community bei und verdienen Sie sich zusätzliche Prämien.`,
        footer: `*Über das Geschenk:</br>
Keine Versandgebühren, keine versteckten Gebühren, keine Kreditkarte erforderlich`,
        btn_text: 'Ich will es'
    },
    // step6
    uploadPic: {
        title: `Bitte laden Sie den Screenshot Ihrer Amazon-Rezension hoch, nachdem Sie sie geschrieben haben.`,
        text: `Sobald Ihre Rezension erfolgreich auf Amazon veröffentlicht wurde, werden wir Sie per E-Mail kontaktieren:
redeem@amazonsurveyzone.com und stellen Ihnen die Mystery Box aus.`,
        add_pic: 'Bilder hinzufügen',
        add_pic_text: 'Normalerweise dauert die Überprüfung durch Amazon 2-3 Tage.',
        btn_text: 'Nächster Schritt'
    },
    // step7
    cityForm: {
        title: '*Zubehör Empfangsadresse: ',
        text: '(Bitte bestätigen Sie Ihre Lieferadresse, das kostenlose Geschenk wird innerhalb von 3-5 Arbeitstagen zugestellt).',
        form_city: 'Stadt',
        form_state: 'Bundesland/Region',
        form_postal_code: 'Postleitzahl',
        form_country: 'Land',
        btn_text: 'Bestätigen Sie',
        "form_city_placeholder": "Bitte geben Sie Ihre Stadt ein",
        "form_state_placeholder": "Bitte geben Sie Ihr Gebiet ein",
        "form_postal_code_placeholder": "Bitte geben Sie Ihre Postleitzahl ein",
        "form_country_placeholder": "Bitte geben Sie Ihr Land ein"
    },
    // step7
    paypalForm: {
        title: '*Konto des Empfängers der Geschenkkarte:',
        text: '(Bitte überprüfen Sie Ihre Kontoinformationen sorgfältig)',
        form_paypal: 'Paypal-Konto',
        form_ensure_paypal: 'Paypal-Konto doppelt bestätigen',
        form_paypal_name: 'Name',
        btn_text: 'Bestätigen Sie',
        "form_paypal_placeholder": "Bitte geben Sie Ihr PayPal-Konto ein",
        "form_ensure_paypal_placeholder": "Bitte bestätigen Sie Ihr PayPal-Konto",
        "form_paypal_name_placeholder": "Bitte geben Sie Ihren PayPal-Namen ein"
    },
    // thanks-all
    thanksAll: {
        "title": "Dankbar für Ihren Beitrag!",
        // title_desc1: 'Vielen Dank für Ihre Teilnahme an unserer Produktumfrage!',
        // title_desc2: 'projector survey!',
        text: `Ihre wertvolle Meinung wird uns helfen, die Produktqualität zu verbessern. 
Wenn Sie während des Gebrauchs Fragen haben, können Sie uns gerne kontaktieren.`
    },
    // thanks
    thanks: {
        "title": "Herzlichen Glückwunsch!",
        title_desc1: `Ihre Garantie ist aktiviert!
Vielen Dank für Ihre Zeit.`,
        title_default_paypal_desc1: `Ihre Garantie ist aktiviert!
Vielen Dank für Ihre Zeit. Ihre Belohnung wird innerhalb von 24 bis 72 Stunden ausgestellt.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
//  现在还差 跳转到亚马逊， 上传亚马逊评论图片，邮件页面